export const quarterlyRoyaltySteps = [
    10000, 12500, 15000, 17500, 20000, 22500, 25000, 30000, 35000, 40000, 45000,
    50000, 75000, 100000, 125000, 150000, 175000, 200000, 225000, 250000,
    275000, 300000, 325000, 350000, 375000, 400000, 425000, 450000, 475000,
    500000,
];

export const planWidth = 300;
export const currentPlanPadding = 16; // w-4, or 1rem
export const futurePlanPadding = 16;
export const sliderPadding = 26;
export const futurePlanSectionHeight = 130;
export const plansWrapperHeight = 769;
export const capacityRequirementsTooltipWidth = 350;

export const basicPlanId = 'CHARGEBEE_PLAN_BASIC' as ChargebeePlanId;
export const proPlanId = 'CHARGEBEE_PLAN_PRO' as ChargebeePlanId;
export const royaltyAddonId = 'CHARGEBEE_ROYALTY_ADD_ON' as ChargebeeAddOnType;
export const detectionAddonId =
    'CHARGEBEE_DETECTION_ADD_ON' as ChargebeeAddOnType;

export const detectionOffset = 20;
